export const errorStateKey = 'error';

export interface ErrorState {
	message: string;
}

export const initialState: ErrorState = <ErrorState>{};
